import ManControllers from "../../../../pages-v1/ManControllers";

export const Page = ManControllers;
